import { Injectable } from '@angular/core';
import {HttpClient, HttpErrorResponse, HttpParams} from "@angular/common/http";
import {environment} from "../../environments/environment";
import {Remito} from "../models/Remito";
import {catchError, map, Observable, throwError} from "rxjs";
import {OpenItem} from "../models/OpenItem";

@Injectable({
  providedIn: 'root'
})
export class OpenItemService {
  private url = environment.openItemsUrl
    private reportUrl = environment.reportUrl;
  remitoParams: HttpParams;

  constructor(private readonly httpClient: HttpClient) { }

  public generateReport(remito: Remito): Observable<OpenItem[]> {

    this.getSearchParams(remito);

    return this.httpClient.get<OpenItem[]>(this.url+'/free_open_remitos', { params: this.remitoParams }).pipe(map(
      allData => {
        return allData.map((allData) => {
          return OpenItem.transformData(allData);
        })
      }),
      catchError(this.handleError));
  }


  getSearchParams(remito: Remito) {

    this.remitoParams = new HttpParams();
    // @ts-ignore
    this.remitoParams = this.remitoParams.append('idSolicitante', remito.idSolicitante);
    // @ts-ignore
    this.remitoParams = this.remitoParams.append('nameSolicitante', remito.nameSolicitante);
    // @ts-ignore
    this.remitoParams = this.remitoParams.append('codAlmacen', remito.almacens)
    // @ts-ignore
    this.remitoParams = this.remitoParams.append('selectedAlmacens', remito.selectedAlmacens);
    // @ts-ignore
    this.remitoParams = this.remitoParams.append('fecARetornar', remito.fecARetornar);

  }


  handleError(error: HttpErrorResponse) {
    return throwError(error);
  }

    parseErrorBlob(err: HttpErrorResponse): Observable<any> {
        const reader: FileReader = new FileReader();
        let jsonError="";
        const obs = new Observable((observer: any) => {
            reader.onloadend = (e) => {
                console.log(JSON.parse((<any>e.target).result));
                observer.error(JSON.parse((<any>e.target).result));
                // alert("Error:\n" + (<any>e.target).result);
                observer.complete();
            }
        });
        reader.readAsText(err.error);
        return obs;
    }

    downloadOpenRemitoPdf(remitos: Remito): Observable<Blob>{
        return this.httpClient.get(this.reportUrl + '/pdf/download/all_open_remitos', { responseType: 'blob', params: this.remitoParams}).pipe(catchError(this.parseErrorBlob));
    }
}
